import { Icon16Done, Icon20CheckCircleOff, Icon20CheckCircleOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { type ChangeEvent, type ReactNode, memo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { QuotaLandingSelectors } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import { NestleFormWrapperContext } from 'reactApp/sections/Nestle/FormWrapper/FormWrapper.context';

import styles from '../CardForm.css';

interface CheckBoxFieldProps {
    field: string;
    children: ReactNode | string;
    isRequired?: boolean;
}

export const CheckboxField = memo<CheckBoxFieldProps>(({ field, children, isRequired = false }) => {
    const { formData, formErrors, setFormData, setFormErrors } = useContext(NestleFormWrapperContext);
    const isMobile = useSelector(QuotaLandingSelectors.isMobile);

    const toggleCheck = (e: ChangeEvent<HTMLInputElement>) => {
        const { name } = e.target;
        setFormData((prev) => ({ ...prev, [name]: !prev[name] }));

        if (formErrors[name]) {
            setFormErrors((prev) => ({ ...prev, [name]: false }));
        }
    };

    return (
        <label
            className={classNames(styles.checkboxWrapper, {
                [styles.bottomWrap]: isRequired,
                [styles.checkboxWrapperMobile]: isMobile,
            })}
            htmlFor={field}
        >
            <input
                type="checkbox"
                id={field}
                name={field}
                checked={formData[field]}
                onChange={toggleCheck}
                className={styles.checkboxInput}
            />

            {isMobile ? (
                <span className={styles.iconWrapper}>
                    {formData[field] ? (
                        <Icon20CheckCircleOutline fill="#0077FF" />
                    ) : formErrors[field] ? (
                        <Icon20CheckCircleOff fill="#FF3A3A" />
                    ) : (
                        <Icon20CheckCircleOff fill="#CFD1D6" />
                    )}
                </span>
            ) : (
                <span
                    className={classNames(styles.customCheckbox, {
                        [styles.validateError]: formErrors[field],
                        [styles.customCheckboxCardDesktop]: !isRequired,
                    })}
                >
                    {formData[field] && <Icon16Done fill="#0070f0" width={15} height={15} />}
                </span>
            )}

            <span
                className={classNames(styles.text, {
                    [styles.textPhone]: isMobile,
                    [styles.textCheckboxItems]: isRequired,
                })}
            >
                {children}
            </span>
        </label>
    );
});

CheckboxField.displayName = 'CheckboxField';
